import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card, Table } from "reactstrap";
import { useLocation } from "react-router-dom";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Pass from "../../../components/Common/Pass";
import passDesign1 from "../../../../src/assets/peach.svg";
import passDesign2 from "../../../../src/assets/green.svg";
import passDesign3 from "../../../../src/assets/purple.svg";
import GymDetails from "../../Gyms/components/GymDetails";
export default function RedeemPassDetail() {
  document.title = "Redeem Pass Detail | Elevated - Admin Dashboard";
  const location = useLocation();
  const navigate = useNavigate();
  const redeemId = location.state?.redeemData?.data[0]?._id;

  const [redeemData, setRedeemData] = useState();
  const [loading, setLoading] = useState(true);

  const fetchRedeemPass = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.redeemDetail}?gymId=${id}`);
      setRedeemData(response?.data?.data[0]);
    } catch (error) {
      console.error("Error fetching pass data:", error);
      setRedeemData(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (redeemId) {
      fetchRedeemPass(redeemId);
    }
  }, []);
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  return (
    <div className="">
      <Container fluid>
        <Card className="rounded-4 p-4">
          <Row className="justify-content-between align-items-center">
            <Col md={6}>
              <h2 className="fw-bold font-size-20 ff-sora primary-black">
                Redeem Pass Detail
              </h2>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12}>
              <span className="font-size-16 my-2 fw-normal fw-bold ff-sora secondary-black">
                General Info
              </span>
              <Col className="mt-3" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Pass
                  code={
                    redeemData?.passDetail?.name +
                    redeemData?.passDetail?.price +
                    redeemData?.passDetail?.duration +
                    redeemData?.gymDetail?.name
                  }
                  name={redeemData?.passDetail?.name || "N/A"}
                  price={redeemData?.passDetail?.price * 10}
                  duration={redeemData?.passDetail?.duration || "N/A"}
                  filter={
                    redeemData?.passDetail?.duration === "oneday"
                      ? passDesign1
                      : redeemData?.passDetail?.duration === "oneweek"
                      ? passDesign2
                      : passDesign3
                  }
                  address={redeemData?.gymDetail?.name
                    .split(" ")
                    .slice(1, 4)
                    .join(" ")}
                  createdAt={redeemData?.passDetail?.createdAt}
                />
              </Col>
              <div
                className="table-responsive hide-scrollbar rounded-4"
                style={{ height: "300px" }}
              >
                {loading ? (
                  <div className=" text-center font-size-16 fw-normal fw-bold ff-sora secondary-black">
                    {/* //loading... */}
                  </div>
                ) : redeemData ? (
                  <Table
                    className="table table-borderless"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <tbody style={{ minHeight: "550px" }}>
                      <tr>
                        <td
                          className="font-size-16 fw-normal col-2 ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          User Name
                        </td>
                        <td className="font-size-16 fw-normal ff-sora flex-nowrap secondary-black text-capitalize">
                          {`${redeemData?.userDetail?.firstName} ${redeemData?.userDetail?.lastName}` ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className=" font-size-16 fw-normal ff-sora"
                          style={{ color: "#9e9e9e" }}
                        >
                          Pass Title
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          {redeemData?.passDetail?.name || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="font-size-16 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Pass Type
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          {redeemData?.passDetail?.duration === "oneweek"
                            ? "One Week"
                            : redeemData?.passDetail?.duration === "oneday"
                            ? "One Day"
                            : redeemData?.passDetail?.duration === "onemonth" &&
                              "One Month"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className=" font-size-16 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Pass Price
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          ${formatNumber(redeemData?.passDetail?.price)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="font-size-16 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Redeem On
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          {redeemData?.createdAt
                            ? new Date(
                                redeemData?.createdAt
                              ).toLocaleDateString()
                            : "N/A"}
                        </td>
                      </tr>
                      {/* <tr>
                        <td
                          className="font-size-16 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Added On
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          {redeemData.createdAt
                            ? new Date(
                                redeemData.createdAt
                              ).toLocaleDateString()
                            : "N/A"}
                        </td>
                      </tr> */}
                    </tbody>
                  </Table>
                ) : (
                  <div
                    className=" text-center font-size-16 fw-normal ff-sora secondary-black"
                    style={{ color: "#525252" }}
                  >
                    No pass data available
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Card>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            height: "0px",
            position: "sticky",
            bottom: "0",
            zIndex: "10",
          }}
        ></div>
      </Container>
    </div>
  );
}
